import React from "react";

export const Canvas = () => {
  return <canvas id="step0" style={{ marginTop: 10 }} />;
};
